<template>
  <div>
    <a ref="lienDownload"></a>
    <v-client-table
      class="fixed_header" ref="tableListeFaceLc"
      :data="data"
      :columns="columns"
      :options="options"
      @filter="tableIsFilter">
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input type="checkbox" id="checkbox" :value="props.row" v-model="props.row.selected"
               @click="ajoutPanier(props.row)">
      </div>
      <div slot="Disponibilite" slot-scope="props"
           class="image is-24x24 button noHandCursor centrer_disponibilite"
           v-bind:class="props.row.dispoClass">
      </div>
      <div slot="affectations" slot-scope="props" >
        <b-dropdown position="is-bottom-left" hoverable aria-role="list">
            <div class="ellipsis ventesLcListeTailleColonneAffectations"
                 slot="trigger">
              {{formatAff(props.row.affectations[0])}}
            </div>
            <b-dropdown-item
              class="itemAff is-default"
              v-for="(aff, i) in props.row.affectations"
              custom
              :key="i">{{formatAff(aff)}}</b-dropdown-item>
        </b-dropdown>
      </div>
      <div slot="affectationsReseaux" slot-scope="props">
        <b-dropdown position="is-bottom-left" hoverable aria-role="list">
            <div class="ellipsis ventesLcListeTailleColonneAffectations"
                 slot="trigger">
              {{formatAff(props.row.affectationsReseaux[0])}}
            </div>
            <b-dropdown-item
              class="itemAff is-default"
              v-for="(aff, i) in props.row.affectationsReseaux"
              custom
              :key="i">{{formatAff(aff)}}</b-dropdown-item>
        </b-dropdown>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { TEXTS, RESULTS_PER_PAGE, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import trierFaces from '@/services/catalogue/trierFaces';
import faceSelectedInitialise from '@/services/catalogue/faceSelectedInitializer';
import gestionErreur from '@/services/general/gestionErreur';
import { getFicheLc } from '@/api/PanneauxLc';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');

export default {
  name: 'liste',
  data() {
    return {
      trad: {
        selected: '',
        facCode: '↑↓ Face',
        panCode: '↑↓ Panneau',
        Format: '↑↓ Format',
        Materiel: '↑↓ Matériel',
        adresse: '↑↓ Adresse',
        CodePostal: '↑↓ C.P.',
        Ville: '↑↓ Ville',
        Departement: '↑↓ Département',
        Disponibilite: 'Dispo',
        nbPropositions: '↑↓ Propals',
        restrictions: '↑↓ Restrictions',
        affectations: '↑↓ Affectation LC',
        affectationsReseaux: '↑↓ Affectation Reseaux',
      },
    };
  },
  watch: {
    filterChanged() {
      // Lorsque les filtres changent on force la passage à la page 1
      // pour éviter d'avoir une liste vide
      this.$refs.tableListeFaceLc.setPage(1);
    },
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      filterChanged: 'filterChanged',
      panneauxLcWithFilter: 'panneauxLcWithFilter',
    }),
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    data() {
      const faces = [];
      const panneaux = this.panneauxLcWithFilter;
      panneaux.forEach(panneau => {
        panneau.faces.forEach(face => {
          // On fait un vrai clone
          const newFace = Object.assign({}, face);
          newFace.panCode = panneau.code;
          newFace.panNum = panneau.num;
          newFace.adresse = panneau.adresseCommercialeLibelle1;
          newFace.ville = panneau.ville;
          newFace.codePostal = panneau.codePostal;
          newFace.departement = panneau.departement;
          newFace.format = panneau.format;
          newFace.materiel = panneau.materiel;
          newFace.dispoClass = niveauDispo.CLASS_NIVEAU_DISPONIBILITE[newFace.niveauDisponibilite];
          newFace.restrictions = panneau.restrictions;
          faces.push(newFace);
        });
      });
      faceSelectedInitialise(faces, this.panneauxLcPanier);
      const listFacesLc = trierFaces(faces);
      listFacesLc.forEach((el) => {
        if (el.affectations.length) {
          el.affLc = '';
          el.affectations.forEach((aff) => {
            el.affLc += `${aff.annonceur} (Du ${moment(aff.dateDebut, 'YYYYMMDD').format('DD/MM/YYYY')} au ${moment(aff.dateFin, 'YYYYMMDD').format('DD/MM/YYYY')})\n`;
          });
        }
        if (el.affectationsReseaux.length) {
          el.affReseaux = '';
          el.affectationsReseaux.forEach((aff) => {
            el.affReseaux += `${aff.resLibelle} (Du ${moment(aff.dateDebut, 'YYYYMMDD').format('DD/MM/YYYY')} au ${moment(aff.dateFin, 'YYYYMMDD').format('DD/MM/YYYY')})\n`;
          });
        }
      });
      this.$emit('liste', {
        data: listFacesLc,
        type: 'faceLc',
      });
      return listFacesLc;
    },
    columns() {
      const listeColumns = ['selected', 'Disponibilite', 'panCode', 'facCode', 'nbPropositions', 'format', 'materiel', 'adresse', 'codePostal', 'ville', 'departement', 'restrictions', 'affectations', 'affectationsReseaux'];
      if (this.panneauxLcWithFilter.length === 0 ||
        this.panneauxLcWithFilter[0].niveauDisponibilite === niveauDispo.DISPONIBILITE_INDEFINI) {
        listeColumns.splice(listeColumns.indexOf('Disponibilite'), 1);
      }
      return listeColumns;
    },
    options() {
      return {
        headings: {
          selected: this.trad.selected,
          panCode: this.trad.panCode,
          facCode: this.trad.facCode,
          propaps: this.trad.propals,
          format: this.trad.Format,
          materiel: this.trad.Materiel,
          adresse: this.trad.adresse,
          codePostal: this.trad.CodePostal,
          ville: this.trad.Ville,
          departement: this.trad.Departement,
          Disponibilite: this.trad.Disponibilite,
          nbPropositions: this.trad.nbPropositions,
          restrictions: this.trad.restrictions,
          affectations: this.trad.affectations,
          affectationsReseaux: this.trad.affectationsReseaux,
        },
        filterByColumn: true,
        filterable: ['panCode', 'facCode', 'nbPropositions', 'format', 'materiel', 'adresse', 'codePostal', 'ville', 'departement', 'restrictions', 'affectations', 'affectationsReseaux'],
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          selected: 'colonneBoutonFaceLcListe',
          Disponibilite: 'colonneBoutonFaceLcListe has-text-centered',
          nbPropositions: 'colonneBoutonFaceLcListe100px ellipsis has-text-centered',
          ville: 'ellipsis ventesReseauxListeTailleColonneVille',
          codePostal: 'colonneBoutonFaceLcListe100px ellipsis has-text-centered',
        },
      };
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setPanneauxLcWithFilter: types.SET_PANNEAUXLC_WITH_FILTER,
    }),
    ...VenteFacesLc.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    ajoutPanier(f) {
      this.actionsGestionPanier({ face: f });
    },
    formatAff(data) {
      if (data) {
        const debut = moment(data.dateDebut, 'YYYYMMDD').format('DD/MM/YYYY');
        const fin = moment(data.dateFin, 'YYYYMMDD').format('DD/MM/YYYY');
        return `${data.annonceur ? data.annonceur : data.resLibelle} (du ${debut} au ${fin})`;
      }
      return '';
    },
    async download(data) {
      const produit = this.panneauxLcWithFilter.find(pan => data.panNum === pan.num);
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const response = await getFicheLc(produit);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        gestionErreur(`Erreur lors de l'impression de la fiche du panneau Lc n°${data.panCode}`, e);
      }
      loadingComponent.close();
    },
    tableIsFilter() {
      this.$emit('liste', {
        data: trierFaces(this.$refs.tableListeFaceLc.filteredData),
        type: 'faceLc',
      });
    },
  },
  mounted() {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recherche/liste.vue